namespace advisorop.services {
    `use strict`;

    export class AccountApi {

        readonly apiUrl = `/api/account`;

        // public account objects to be shared between controllers
        // The following are used by new-new-account-wiz
        // Are we creating a new account or editing an existing account
        public accountWizEditing;
        // the account
        public paccount: domains.IAccount = { id: 0, name: "", number: "", company: "", productDescription: "", directManagerDesc: "", notes: "", docRequests: [], manualAccount: {}, investors: [], rtgs: [], holdingsMaintaindExSystem: true, setupCreationType: domains.AccountCreationType.NEW_ACCOUNT };
        // the custodian account
        public pcustodianAccount: domains.IAccount = { id: 0, name: "", number: "", company: "", productDescription: "", directManagerDesc: "", notes: "", docRequests: [], manualAccount: {}, investors: [], rtgs: [], holdingsMaintaindExSystem: true, isNumberReserved: false, isDiscretionDocumentationOnFile: false, sweepFundsPercent: 0 };
        // dirty/clean indicators used by new-new-account-wiz related controllers
        public basicSetupDirty: boolean;
        public rtgInformationComplete: boolean = false;
        public investmentSetupDirty: boolean;
        public feeSetupDirty: boolean;
        public signingSetupDirty: boolean;

        static $inject = [`$http`];
        constructor(private $http: ng.IHttpService) {
        }

        //public isCustodianRequired(): boolean {
        //    return (
        //        (this.paccount.accountType &&
        //            (this.paccount.accountType == domains.InvestmentType.INDIVIDUAL_HOLDINGS ||
        //            this.paccount.accountType == domains.InvestmentType.MANAGED_MODELS ||
        //            this.paccount.accountType == domains.InvestmentType.SMA)
        //        ) ||
        //        (this.paccount.accountType == domains.InvestmentType.DIRECT_INVESTMENT
        //            && this.paccount.productTypeId == domains.ProductType.REIT
        //            && (this.paccount.titleType == domains.TitleType.IRA || this.paccount.titleType == domains.TitleType.OTHER_RETIREMENT)
        //        )
        //    );
        //}

        getById(id: number): ng.IHttpPromise<domains.IAccount> {
            return this.$http.get(`${this.apiUrl}/${id}`);
        }

        getBoAccounts(id: number): ng.IHttpPromise<domains.IBOAccount[]> {
            return this.$http.get(`${this.apiUrl}/${id}/boaccounts`);
        }

        getCustodianAccounts(accountId: number, includeSetupAccounts: boolean): ng.IHttpPromise<domains.IAccount[]> {
            return this.$http.get(`${this.apiUrl}/${accountId}/caaccounts?includeSetupAccounts=${includeSetupAccounts || null}`);
        }

        getBeneficiaries(id: number): ng.IHttpPromise<domains.IAccountBeneficiary[]> {
            return this.$http.get(`${this.apiUrl}/${id}/beneficiaries`);
        }

        setUpdateFrequency(accountId: number, updateFrequency: number): ng.IHttpPromise<any> {
            return this.$http.post(`${this.apiUrl}/${accountId}/set-update-frequency`, updateFrequency);
        }

        getAccountsBySecurity(adminModeEnabled: boolean, uniqueSecId: string, advisoryFirmId?: number): ng.IHttpPromise<Array<domains.IAccountBOAccountData>> {

            let url = `/api/account/by-security/${uniqueSecId}?adminModeEnabled=${adminModeEnabled}`;

            if (advisoryFirmId && advisoryFirmId > 0) {
                url = `${url}&advisoryFirmId=${advisoryFirmId}`;
            }

            return this.$http.get(url);
        }

        getAccountsBySearchTerm(adminModeEnabled: boolean, searchTerm: string, advisoryFirmId?: number): ng.IHttpPromise<Array<domains.IAccountBOAccountData>> {

            let url = `/api/account/by-full-text/?searchTerm=${searchTerm}&adminModeEnabled=${adminModeEnabled}`;

            if (advisoryFirmId && advisoryFirmId > 0) {
                url = `${url}&advisoryFirmId=${advisoryFirmId}`;
            }

            return this.$http.get(url);
        }

        getAccountsByManagerProduct(managerId: number, managerProductId: number, advisoryFirmId: number, adminModeEnabled: boolean): ng.IHttpPromise<Array<domains.IAccountBOAccountData>> {

            let url = `/api/account/by-manager-product?adminModeEnabled=${adminModeEnabled}`;

            if (managerId && managerId > 0) {
                url = `${url}&managerId=${managerId}`;
            }

            if (managerProductId && managerProductId > 0) {
                url = `${url}&managerProductId=${managerProductId}`;
            }

            if (advisoryFirmId && advisoryFirmId > 0) {
                url = `${url}&advisoryFirmId=${advisoryFirmId}`;
            }

            return this.$http.get(url);
        }

        getAccountBySecuritiesManagersProducts(uniqueSecurityIds: Array<string>, managerIds: Array<number>, productIds: Array<number>, advisoryFirmId: number, adminModeEnabled: boolean): ng.IHttpPromise<Array<domains.IAccountBOAccountData>> {
            let url = `/api/account/by-securities-managers-products?adminModeEnabled=${adminModeEnabled}`;
            if (advisoryFirmId && advisoryFirmId > 0) {
                url = `${url}&advisoryFirmId=${advisoryFirmId}`;
            }

            return this.$http.post(url, JSON.stringify({
                "uniqueSecurityIds": uniqueSecurityIds, "managerIds": managerIds, "managerProductIds": productIds }));
        }
        syncAccountGroupsToBOSystem(accountId: number): ng.IHttpPromise<any> {
            return this.$http.post(`${this.apiUrl}/${accountId}/sync-account-groups-with-bo-system`, null);
        };

        getActiveSecurityAllocationPlan(accountId: number): ng.IHttpPromise<domains.IAFSecurityAllocationPlan> {
            return this.$http.get(`${this.apiUrl}/${accountId}/activesecurityallocationplan`);
        }

    }
    angular.module(Constants.ADVOP_SERVICES).service("accountApi", AccountApi);
}